import { render, staticRenderFns } from "./StatisticsBox.vue?vue&type=template&id=77328851&scoped=true"
import script from "./StatisticsBox.vue?vue&type=script&lang=js"
export * from "./StatisticsBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77328851",
  null
  
)

export default component.exports